import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <>
      <div className="inner-banner before-none bg-white border-top">
        <div className="container">
          <div className="inner-banner-txt">
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Privacy Policy{" "}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <section className="main-section default-page border-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-sm-12 col-xs-12">
              <div className="main-title wow fadeInUp mb-5">
                <h2 className="fs-35 wow fadeInUp fadeIn">Privacy Policy</h2>
              </div>
              <div className="privacy-policy-txt">
                <p>
                  Simply dummy text of the printing and typesetting industry.
                  Ipsumes has been the industry's standard dummy text ever since
                  the 1500s, when an unknown printer took a galley of type and
                  scrambled it to make a type specimen book. It has survived not
                  only five centuries, but also the leap into electronic
                  typesetting, remaining essentially unchanged. It was
                  popularised in the 1960s with the release of Letraset sheets
                  containing Ipsumes passages, and more recently with desktop
                  publishing software like Aldus PageMaker including versions of
                  Ipsumes.
                </p>
                <h3>Why choose us fashion Hub</h3>
                <p>
                  {" "}
                  Ipsumes is simply dummy text of the printing and typesetting
                  industry. Ipsumes has been the industry's standard dummy text
                  ever since the 1500s, when an unknown printer took a galley of
                  type and scrambled it to make a type specimen book. It has
                  survived not only five centuries, but also the leap into
                  electronic typesetting, remaining essentially unchanged. It
                  was popularised in the 1960s with the release of Letraset
                  sheets containing Ipsumes passages, and more recently with
                  desktop publishing software like Aldus PageMaker including
                  versions of Ipsumes.
                </p>
                <h4>Why choose us fashion Hub</h4>
                <p>
                  All the data display on the site exclusively has a place with{" "}
                  <strong> fashion Hub </strong> Ipsumes is simply dummy text of
                  the printing and typesetting industry. Ipsumes has been the
                  industry's standard dummy text ever since the 1500s, when an
                  unknown printer took a galley of type and scrambled it to make
                  a type specimen book. It has survived not only five centuries,
                  but also the leap into electronic typesetting, remaining
                  essentially unchanged. It was popularised in the 1960s with
                  the release of Letraset sheets containing Ipsumes passages,
                  and more recently with desktop publishing software like Aldus
                  PageMaker including versions of Ipsumes.
                </p>
                <ul>
                  <li>All the data display on the site exclusively</li>
                  <li>Display on the site exclusively</li>
                  <li>All the data display on the site exclusively</li>
                  <li>All the data display on the site exclusively</li>
                  <li>All the data display on the site exclusively</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
